import React, {
  type Dispatch,
  type ReactElement,
  type SetStateAction,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  FooterActionBar,
  ModalIsland,
  RadioButton,
} from '@saviynt/design-system';

import { useInvertedLocalize, useTypedSelector } from '../../../shared/hooks';
import { type RootState } from '../../../shared/types';
import { violationsReportActions } from '../data-store/violationsReportSlice';

import './ViolationsReport.css';

interface ReportModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * ReportModal
 */
function ReportModal({ isOpen, setIsOpen }: ReportModalProps): ReactElement {
  const dispatch = useDispatch();
  const l = useInvertedLocalize();

  const { selectedReport } = useTypedSelector(
    (state: RootState) => state.aag.report
  );
  const [radioValue, setRadioValue] = useState(selectedReport);

  const handleClick = (e: object, value: string) => {
    setRadioValue(value);
  };

  const getIpsumText = (value: number) =>
    `Repeat ipsum ${value}. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat facilisi egestas felis purus ut. `.repeat(
      value
    );

  const reportType = [
    {
      id: 'radioButton1',
      name: 'radioGroupKinds',
      title: 'Violations',
      description: getIpsumText(1),
      value: '0',
      radioSelection: radioValue,
      onClick: handleClick,
    },
    {
      id: 'radioButton1',
      name: 'radioGroupKinds',
      title: 'Entitlements with Inherent Risks',
      description: getIpsumText(1),
      value: '1',
      radioSelection: radioValue,
      onClick: handleClick,
    },
    {
      id: 'radioButton1',
      name: 'radioGroupKinds',
      title: 'Roles with Inherent Risks Summary',
      description: getIpsumText(1),
      value: '2',
      radioSelection: radioValue,
      onClick: handleClick,
    },
    {
      id: 'radioButton1',
      name: 'radioGroupKinds',
      title: 'Mitigating Controls About to Expire in 30 Days',
      description: getIpsumText(1),
      value: '3',
      radioSelection: radioValue,
      onClick: handleClick,
    },
    {
      id: 'radioButton1',
      name: 'radioGroupKinds',
      title: 'Mitigating Controls Assigned Associations End Date in 30 days',
      description: getIpsumText(1),
      value: '4',
      radioSelection: radioValue,
      onClick: handleClick,
    },
  ];

  const body = () => (
    <Box className='ReportModal-body'>
      {reportType.map((report) => (
        <RadioButton
          id={report.id}
          name={report.name}
          title={l(report.title)}
          description={l(report.description)}
          value={report.value}
          radioSelection={report.radioSelection}
          onClick={report.onClick}
        />
      ))}
    </Box>
  );

  const handlePreviewclick = () => {
    setIsOpen(false);
    dispatch(violationsReportActions.setSelectedReport(radioValue));
  };

  const renderFooter = () => (
    <FooterActionBar size='large'>
      <Box className='ReportModal-footer'>
        <Button kind='subtle' size='medium' onClick={() => setIsOpen(false)}>
          {l('Cancel')}
        </Button>
        <div className='ReportModal-footer--primary'>
          <Button kind='outlined' size='medium' onClick={() => {}}>
            {l('Export')}
          </Button>
          <Button kind='filled' size='medium' onClick={handlePreviewclick}>
            {l('Preview')}
          </Button>
        </div>
      </Box>
    </FooterActionBar>
  );

  return (
    <ModalIsland
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      title={l('Report')}
      contentBody={body()}
      FooterActionBarComp={renderFooter()}
    />
  );
}

export default ReportModal;
